import React from "react";
import memoizeOne from "memoize-one";
import { DeleteOutlineOutlined, CreateOutlined } from "@material-ui/icons";
// import { ApiConfig } from "../../../../api/apiConfig/apiConfig";
import moment from "moment";


const TablesColumns = memoizeOne((handleEdit, handleDelete) => [
    {
        name: "Title",
        selector: "PublicationDetailTitle",
        grow: 0.5,
        sortable: false,
        cell: (row) => <div>{row.title}</div>,
        
    },
    {
        name: "Author",
        selector: "PublicationDetailTitle",
        grow: 0.2,
        sortable: false,
        cell: (row) => <div>{row.author}</div>,
        
    },
    {
        name: "Date",
        selector: "PublicationDetailTitle",
        grow: 0.1,
        sortable: false,
        cell: (row) => <div> {moment(row.date).format('yyyy')}</div>,
        
    },
    {
        name: "Status",
        selector: "status",
        sortable: false,
        grow: 0.1,
        cell: (row) => <div>{`${row.status === 1 ? 'Active' : 'InActive'}`}</div>,
    },
    {
        name: "Action",
        selector: "",
        sortable: false,
        grow: 0.1,
        ignoreRowClick: true,
        allowOverflow: true,
        cell: (row) => (
            <div className="d-flex">
                <div onClick={() => handleDelete(row)}>
                    <DeleteOutlineOutlined style={{ color: "#ec0707" }} />
                </div>
                <div onClick={() => handleEdit(row)}>
                    <CreateOutlined style={{ color: "#00BCD4" }} />
                </div>
            </div>
        ),
    },

]);




export default TablesColumns;
